/**
 * H5 报名入口活动别名：已发出的旧二维码活动 → 正确活动。
 * 与后端 config/registration.php activity_aliases 保持一致。
 *
 * TODO(活动结束后删除)：临时兼容旧码 activity/23 → 22（问卷 35），活动结束后清空此映射。
 *
 * @type {Record<number, number>}
 */
export const REGISTRATION_ACTIVITY_ALIASES = {
  23: 22
}

/** @param {number|null|undefined} activityId */
export function resolveRegistrationActivityAlias (activityId) {
  const id = Number(activityId)
  if (!Number.isInteger(id) || id <= 0) return activityId ?? null
  const target = REGISTRATION_ACTIVITY_ALIASES[id]
  return Number.isInteger(target) && target > 0 ? target : id
}
